import React from "react";

const SVG = ({
  style = {},
  fill = "#000",
  className = "",
  width="22.923", 
  height="20.305", 
  viewBox="0 0 22.923 20.305"
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path fill={fill} d="M148.249 170.3l-12.011-9.885a.255.255 0 0 0-.409.263l1.768 6.632-11.936.664a.255.255 0 0 0-.241.255v4.653a.255.255 0 0 0 .241.255l11.7.651-1.562 6.556a.255.255 0 0 0 .411.256l12.038-9.907a.255.255 0 0 0 .001-.393z" className="cls-1" transform="rotate(180 74.171 90.329)"/>
  </svg>
);

export default SVG;



// WEBPACK FOOTER //
// ./src/components/UI/Icons/ArrowLeft.js